import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconKippyLightProps } from './IconKippyLight.types'
import * as Styled from './styles/IconKippyLight.style'

import { nonThemeableRules } from '../../ruleSet'

const IconKippyLight: FC<IconKippyLightProps> = ({
  size = nonThemeableRules.defaultSize as number as IconKippyLightProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconKippyLightProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M7.168 19.527 8.695 18m3.309 3.531v-2.16m4.836.16-1.527-1.527M12 2.559c-4.125 0-6.559.32-7.875 1.898C2.809 6.035 2.5 7.234 2.5 9.277c0 2.047.32 3.25 1.637 4.825C5.453 15.672 7.875 16 12 16s6.559-.32 7.875-1.898c1.316-1.579 1.637-2.778 1.637-4.825 0-2.043-.32-3.242-1.637-4.82C18.559 2.879 16.137 2.559 12 2.559Zm.004 8.941v2'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconKippyLight
